import { Link } from "react-router-dom";
import { hotRanking, topics } from "@/mocks/topics";

const stats = [
  { value: "328", label: "已完成复盘事件" },
  { value: "4,120", label: "累计时间线节点" },
  { value: "6,800+", label: "引用与交叉信源" },
];

export default function Hero() {
  const featured = topics[0];

  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 py-12 md:px-8 md:py-16 lg:grid-cols-12 lg:gap-12">
        <div className="flex flex-col justify-center lg:col-span-7">
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            <i className="ri-sparkling-2-line"></i>
            热点不只看热闹，更看脉络
          </span>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            黑料热点：看懂每一个热点，
            <br className="hidden sm:block" />
            从发酵到真相
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600">
            我们把刷屏的片段、互相矛盾的说法和零散的截图，重新排成一条清晰的时间线。
            从事件起因、发酵节点到各方回应，再逐层剥开背后真相与深层原因，给你一份真正能读完的完整复盘。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-history-line text-base"></i>
              浏览最新复盘
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              了解复盘方法
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>

          <dl className="mt-9 grid grid-cols-1 gap-5 border-t border-background-200 pt-6 sm:grid-cols-3">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="font-heading text-2xl font-bold text-foreground-950">{item.value}</dt>
                <dd className="mt-1 text-sm text-foreground-500">{item.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-5">
          <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="relative h-56 w-full overflow-hidden bg-background-200 md:h-64">
              <img
                src={featured.cover}
                alt="青禾乳业联名定价争议事件复盘封面"
                title="青禾乳业联名定价争议 - 热点事件时间线复盘"
                className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                <i className="ri-fire-line"></i>
                今日焦点
              </span>
            </div>
            <div className="p-5">
              <h2 className="font-heading text-lg font-bold leading-snug text-foreground-950">
                <Link to={`/topic/${featured.id}`} className="transition-colors hover:text-primary-600">
                  {featured.title}
                </Link>
              </h2>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {featured.summary}
              </p>
              <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-node-tree"></i>
                  {featured.timeline.length} 个关键节点
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-links-line"></i>
                  引用 {featured.sources} 个信源
                </span>
              </div>
            </div>
          </article>

          <div className="mt-5 rounded-lg border border-background-200 bg-background-100 p-5">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
                <i className="ri-bar-chart-2-line text-primary-500"></i>
                今日热度榜
              </h2>
              <Link to="/topics" className="text-xs text-foreground-500 transition-colors hover:text-primary-600">
                查看全部
              </Link>
            </div>
            <ul className="mt-4 space-y-3">
              {hotRanking.slice(0, 5).map((item, index) => (
                <li key={item.id} className="flex items-center gap-3">
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                      index < 3 ? "bg-primary-500 text-background-50" : "bg-background-300 text-foreground-700"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <Link
                    to={`/topic/${item.id}`}
                    className="min-w-0 flex-1 truncate text-sm text-foreground-800 transition-colors hover:text-primary-600"
                    title={item.title}
                  >
                    {item.title}
                  </Link>
                  <span className="shrink-0 text-xs font-medium text-accent-700">{item.heat}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}